import React from 'react';

const ColumnViewTypeIcon = (props) => {
    return (
        <svg width={props.width} height={props.height} viewBox="0 0 16 16" fill="none">
            <mask id="path-1-inside-1_9833_53763" fill="white">
                <rect x="2" y="2" width="5.5" height="12" rx="1" />
            </mask>
            <rect
                x="2"
                y="2"
                width="5.5"
                height="12"
                rx="1"
                stroke={props.color}
                strokeWidth="3"
                mask="url(#path-1-inside-1_9833_53763)"
            />
            <mask id="path-2-inside-2_9833_53763" fill="white">
                <rect x="8.5" y="2" width="5.5" height="12" rx="1" />
            </mask>
            <rect
                x="8.5"
                y="2"
                width="5.5"
                height="12"
                rx="1"
                stroke={props.color}
                strokeWidth="3"
                mask="url(#path-2-inside-2_9833_53763)"
            />
        </svg>
    );
};

export default ColumnViewTypeIcon;
